export const dropdownMenu = {
  profile: "Personal Area",
  mobilePaidAccounts: "Mobile Payment Accounts",
  movements: "Movements",
  contact: "Contacts",
  changePassword: "Change Password",
  inviteFriend: "Invite a friend",
  deposit: "Deposits",
  withdrawal: "Withdrawal",
  transfer: "Transfer",
  logout: "Logout",
  points: "Points",
  xpPoints: "XP",
  tokens: "Tokens",
  level: "Level",
  language: "Language",
  backToPersonalArea: "Back to Personal Area",
};
